import { Input, InputField } from 'aos-ui-universal'
import React, { FC, useState } from 'react'

import { parseNumberField } from './parseNumberField'

interface NumberFieldProps {
    value: number
    onChange(value: number): void
    disabled?: boolean
    className?: string
}

export const NumberField: FC<NumberFieldProps> = ({ value, onChange, disabled, className }) => {
    const [text, setText] = useState(String(value))
    const [prevValue, setPrevValue] = useState(value)
    if (value !== prevValue) {
        setPrevValue(value)
        setText(String(value))
    }

    const handleChange = (next: string) => {
        const digits = next.replace(/\D/g, '')
        setText(digits)
        const parsed = parseNumberField(digits)
        if (parsed !== null) {
            onChange(parsed)
        }
    }

    return (
        <Input isDisabled={disabled} className={className}>
            <InputField
                value={text}
                keyboardType='numeric'
                onChangeText={handleChange}
                onBlur={() => setText(String(value))}
                editable={!disabled}
            />
        </Input>
    )
}
